import React, { useEffect, useState } from 'react';
import Apiservice from '../Apiservice';
import { useNavigate, useParams } from 'react-router-dom';
import SiteProfilePDF from './SiteProfilePDF';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { formatTime, calculateWorkingHours } from '../Utils/Utils';
import { Modal, Button } from "react-bootstrap";


const SiteProfile = () => {
  const navigate = useNavigate();
  const { siteId } = useParams();
  const [site, setSite] = useState({});
  const [address, setAddress] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [presentUsers, setPresentUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {

      const currentDate = new Date();

      // Extract year, month, and day
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed, so add 1
      const day = currentDate.getDate().toString().padStart(2, '0'); // Pad with leading zero if needed

      const formattedDate = `${year}-${month}-${day}`;
      const data = {
        siteId: siteId,
        entryTime: formattedDate,
        status: 0
      };
      const result = await Apiservice.SiteProfile(data);
      if (result.success === true) {
        const siteInfo = result.data;
        setSite(siteInfo);
        setAddress(siteInfo.address || []);
        setAssignedUsers(siteInfo.assignedUsers || []);
        setPresentUsers(siteInfo.presentUsers || []);
        setLoading(false)
      }
    };
    fetchData();
  }, []);

  const handleEdit = () => {
    navigate('/siteedit', { state: { siteId } });
  };
  const handleDeleteConfirm = async () => {
         // console.log("handle Delete Confirm")
          let data = {
              siteId: siteId,
              status: 0
          }
          // const token = localStorage.getItem("access_token");
  
          // // Define custom headers
          // const headers = {
          //     access_token: token, // Pass the token in the Authorization header
          // };
          let result = await Apiservice.SoftDeleteSite(data);
          // console.log(result);
          if (result.success === true) {
              navigate('/sites');
          } else {
              alert(result.message)
          }
      }

  return (
    <div className="container mt-5">
      {loading ? (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
          <div className="text-center">
            {/* Spinner with proper rotation */}
            <div
              className="spinner-border text-primary"
              role="status"
              style={{
                width: "2rem",
                height: "2rem",
                borderWidth: "3px",
              }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Minimalist Text */}
            <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
          </div>
        </div>
      )
        : (
          <>
            <div className="card shadow mb-4 border-0">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Site Profile</h5>
              </div>
              <div className="card-body">
                <div className="row mb-2">
                  <div className="col-3 fw-bold">Site Name</div>
                  <div className="col-1">:</div>
                  <div className="col">{site.name || '-'}</div>
                </div>

                {address.length > 0 && (
                  <>
                    <div className="row mb-2">
                      <div className="col-3 fw-bold">Address</div>
                      <div className="col-1">:</div>
                      <div className="col">
                        {address[0]?.unitNo || '-'}, {address[0]?.street || '-'},
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-3"></div>
                      <div className="col-1"></div>
                      <div className="col">{address[0]?.country} - {address[0]?.pincode}.</div>
                    </div>
                    
                    <div className="row mb-2">
                      <div className="col-3"></div>
                      <div className="col-1"></div>
                      <div className="col">Mobile No. : {site.countryCode + site.mobileNo || '-'}</div>
                    </div>
                     <div className="row mb-2">
                      <div className="col-3"></div>
                      <div className="col-1"></div>
                      <div className="col">Email Id : {site.emailId || '-'}</div>
                    </div>
                  </>
                )}
                <div className="row text-end">
                  <div className="col">
                    <button className='btn btn-sm btn-outline-primary m-2' onClick={handleEdit}>Edit</button>
                     <button className='btn btn-sm btn-outline-danger' onClick={()=>setDeleteModal(true)}>Delete</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="m-2 text-end">
              <PDFDownloadLink
                document={<SiteProfilePDF site={site} assignedUsers={assignedUsers} address={address} presentUsers={presentUsers} />}
                fileName={`${site.name} profile.pdf`}  // Fixed template literal syntax
              >
                {({ loading }) => (
                  loading ?
                    <button className="btn btn-primary" disabled>Generating PDF...</button> :
                    <button className="btn btn-success">Download PDF</button>
                )}
              </PDFDownloadLink>
            </div>
            <div className="card shadow border-0">
              <div className="card-header bg-success text-white text-center">
                <h6 className="mb-0">
                  {assignedUsers.length > 0 ? 'Site Staffs' : 'No Staff Available'}
                </h6>
              </div>

              {assignedUsers.length > 0 && (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped mb-0">
                    <thead className="table-light">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Staff Id</th>
                        <th scope="col">Name</th>
                        <th scope="col">Designation</th>
                        <th scope="col">Contact Number</th>
                        <th scope="col">Time In</th>
                        <th scope="col">Time Out</th>
                        <th scope="col">Total Hrs</th>
                        <th scope="col">Time In Location</th>
                        <th scope="col">Time Out Location</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignedUsers.map((user, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{user.id}</td>
                          <td>{user.firstName} {user.lastName}</td>
                          <td>{user.roleName || '-'}</td>
                          <td>{user.countryCode + user.mobileNo || '-'}</td>
                          <td>{user.entryTime ? formatTime(user.entryTime) : '-'}</td>
                          <td>{user.exitTime ? formatTime(user.exitTime) : '-'}</td>
                          <td>{user.exitTime && user.entryTime ? calculateWorkingHours(user.entryTime, user.exitTime) : '-'}</td>
                          {/* <td><iframe
                      src={`https://www.google.com/maps?q=12.717261,79.95392&z=15&output=embed`}
                      width="100%"
                      height="300"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                    /></td> */}
                          <td>{user.entryMapUrl ? <a href={user.entryMapUrl} target="_blank" rel="noopener noreferrer">
                            View
                          </a> : '-'}</td>

                          <td>{user.exitMapUrl ? <a href={user.exitMapUrl} target="_blank" rel="noopener noreferrer">
                            View
                          </a> : '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            {
              presentUsers.length > 0 && (
                <div className="card shadow border-0 mt-2 mb-2">
                  <div className="card-header bg-danger text-white text-center">
                    <h6 className="mb-0">Extra or Alternative Assigned Staffs</h6>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped mb-0">
                      <thead className="table-light">
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Staff Id</th>
                          <th scope="col">Name</th>
                          <th scope="col">Designation</th>
                          <th scope="col">Contact Number</th>
                          <th scope="col">Time In</th>
                          <th scope="col">Time Out</th>
                          <th scope="col">Total Hrs</th>
                          <th scope="col">Time In Location</th>
                          <th scope="col">Time Out Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {presentUsers.map((puser, index) => {
                          const matchedUser = assignedUsers.filter(user => user.id === puser.id);

                          // If no match is found, matchedUser will be an empty array, so we return null.
                          if (matchedUser.length === 0) {
                            console.log('No match for user:', puser); // Optional: To see the unmatched users
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{puser.id}</td>
                                <td>{puser.firstName} {puser.lastName}</td>
                                <td>{puser.roleName || '-'}</td>
                                <td>{puser.countryCode + puser.mobileNo || '-'}</td>
                                <td>{puser.entryTime ? formatTime(puser.entryTime) : '-'}</td>
                                <td>{puser.exitTime ? formatTime(puser.exitTime) : '-'}</td>
                                <td>{puser.exitTime && puser.entryTime ? calculateWorkingHours(puser.entryTime, puser.exitTime) : '-'}</td>
                                <td>
                                  {puser.entryMapUrl ? (
                                    <a href={puser.entryMapUrl} target="_blank" rel="noopener noreferrer">
                                      View
                                    </a>
                                  ) : '-'}
                                </td>
                                <td>
                                  {puser.exitMapUrl ? (
                                    <a href={puser.exitMapUrl} target="_blank" rel="noopener noreferrer">
                                      View
                                    </a>
                                  ) : '-'}
                                </td>
                              </tr>
                            );
                          }

                          // If there is a match, return the row with matched user details
                          const user = matchedUser[0]; // Since filter returns an array, we can access the first matched user
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{user.id}</td>
                              <td>{user.firstName} {user.lastName}</td>
                              <td>{user.roleName || '-'}</td>
                              <td>{user.countryCode + user.mobileNo || '-'}</td>
                              <td>{user.entryTime || '-'}</td>
                              <td>{user.exitTime || '-'}</td>
                              <td>
                                {user.entryMapUrl ? (
                                  <a href={user.entryMapUrl} target="_blank" rel="noopener noreferrer">
                                    View
                                  </a>
                                ) : '-'}
                              </td>
                              <td>
                                {user.exitMapUrl ? (
                                  <a href={user.exitMapUrl} target="_blank" rel="noopener noreferrer">
                                    View
                                  </a>
                                ) : '-'}
                              </td>
                            </tr>
                          );
                        })}


                      </tbody>
                    </table>
                  </div>

                </div>
              )
            }
          </>
        )
      }
       {deleteModal && (
                                      <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                                          <Modal.Header closeButton>
                                              <Modal.Title>Delete ?</Modal.Title>
                                          </Modal.Header>
                                          <Modal.Body>
                                              Are you sure you want to Delete?
                                          </Modal.Body>
                                          <Modal.Footer>
                                              <Button
                                                  variant="secondary"
                                                  onClick={() => setDeleteModal(false)}
                                                  style={{ cursor: 'pointer' }} // Ensures proper pointer cursor
                                              >
                                                  Cancel
                                              </Button>
                                              <Button
                                                  variant="danger"
                                                  onClick={handleDeleteConfirm}
                                                  style={{ cursor: 'pointer' }} // Ensures proper pointer cursor
                                              >
                                                  Delete
                                              </Button>
                                          </Modal.Footer>
                                      </Modal>
                                  )}
    </div>
  );
};

export default SiteProfile;
